import {
  ApplicationConfig,
  provideBrowserGlobalErrorListeners,
  provideZoneChangeDetection,
} from '@angular/core';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideRouter } from '@angular/router';

import { AUTH_ENV } from '@auth/app/core/tokens';
import { authInterceptors, authProviders } from '@auth/app/auth.config';
import { commonInterceptors, commonProviders } from '@common/app/common.config';
import { ISSUER_ENV } from '@issuer/app/core/tokens';
import { issuerInterceptors, issuerProviders } from '@issuer/app/issuer.config';
import { EQAUTH_ENV } from '@auth-admin/app/core/tokens';
import { authAdminInterceptors, authAdminProviders } from '@auth-admin/app/auth-admin.config';
import { PAYMENT_ENV } from '@payments/app/core/tokens';
import { paymentsInterceptors, paymentsProviders } from '@payments/app/payments.config';
import { environment } from '@env/environment';
import { APP_ENV } from '@env/tokens';
import { routes } from './app.routes';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideBrowserGlobalErrorListeners(),
    provideRouter(routes),
    { provide: APP_ENV, useValue: environment },
    { provide: AUTH_ENV, useValue: environment.auth },
    { provide: ISSUER_ENV, useValue: environment.issuer },
    { provide: EQAUTH_ENV, useValue: environment.eqauth },
    { provide: PAYMENT_ENV, useValue: environment.payment },
    ...commonProviders,
    ...authProviders,
    ...issuerProviders,
    ...authAdminProviders,
    ...paymentsProviders,
    provideHttpClient(
      withInterceptors([
        ...authInterceptors,
        ...commonInterceptors,
        ...issuerInterceptors,
        ...authAdminInterceptors,
        ...paymentsInterceptors,
      ]),
    ),
  ],
};
